import { ErrorKey, ErrorMessage } from './error.model';
import { AUTH_BACKEND_ERROR_TYPES } from '../auth/auth.const';
import { AI_BACKEND_ERROR_TYPES } from '../ai/ai.const';

export const ERROR_MAP = (<const>{
  [AUTH_BACKEND_ERROR_TYPES.USER_PASSWORD_EXPIRED_ERROR]: {
    logMessage: 'User password expired',
    uiMessage: 'Срок действия вашего кода истек.'
  },
  [AUTH_BACKEND_ERROR_TYPES.INVALID_PASSWORD_ERROR]: {
    logMessage: 'Invalid password',
    uiMessage: 'Неверный код. Попробуйте еще раз.'
  },
  [AUTH_BACKEND_ERROR_TYPES.USER_NOT_FOUND_ERROR]: {
    logMessage: 'User not found',
    uiMessage: 'Пользователь не найден.'
  },
  [AI_BACKEND_ERROR_TYPES.QUESTION_NOT_FOUND_ERROR]: {
    logMessage: 'Question not found',
    uiMessage: 'Вопрос не найден'
  },
  MISSING_REFRESH_TOKEN: {
    logMessage: 'Refresh token is missing',
    uiMessage: 'Пожалуйста, войдите снова'
  },
  UNKNOWN_ERROR: {
    logMessage: 'Something went wrong',
    uiMessage: 'Что-то пошло не так. Пожалуйста, попробуйте позже.'
  },
  NO_DATA_PROVIDED: {
    logMessage: 'No data provided',
    uiMessage: 'Что-то пошло не так. Пожалуйста, попробуйте позже.'
  },
  USER_NOT_LOGGED_IN: {
    logMessage: 'User is not logged in',
    uiMessage: 'Пользователь не авторизован'
  }
}) satisfies Record<string, ErrorMessage>;

export const ERROR_TYPES = Object.keys(ERROR_MAP).reduce(
  (acc, key) => {
    const typedKey = <ErrorKey>key;
    acc[typedKey] = typedKey;
    return acc;
  },
  <Record<ErrorKey, ErrorKey>>{}
);
